module.exports = __webpack_public_path__ + "static/media/NorthWestTelegraph-socshare-min.01c5a3e2.jpg";